import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { isMobileView } from '@core/utils';

export const PlatformRouteGuard: CanActivateFn & CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);

  const isMobile = isMobileView();
  const isMobileRoute = state.url.startsWith('/m/');

  // Prevent infinite loops by checking if the current state matches the expected route format
  if (isMobile && !isMobileRoute) {
    router.navigate([`/m${state.url}`]);
    return false;
  } else if (!isMobile && isMobileRoute) {
    router.navigate([state.url.substring(2)]);
    return false;
  }

  return true;
};
